import React, { useState } from 'react';
import AnimateOnScroll from './../../components/common/animate';
import { Link } from 'react-router-dom';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import FormInput from '../common/formInput';
import { Helmet } from 'react-helmet';

export default function Contact() {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile_number: '',
    message: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
  const { name, value } = e.target;
  const maxLength = 12;

  if (e.target.type === 'number' && value.length > maxLength) return;

  setFormData((prev) => ({ ...prev, [name]: value }));
  if (errors[name]) {
    setErrors((prev) => ({ ...prev, [name]: '' }));
  }
};

  const validate = () => {
    const tempErrors = {};
    if (!formData.name.trim()) tempErrors.name = 'Name is required';
    if (!formData.email.trim()) {
      tempErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = 'Email is invalid';
    }
    if (!formData.mobile_number.trim()) tempErrors.mobile_number = 'Mobile Number is required';
    if (!formData.message.trim()) tempErrors.message = 'Message is required';

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const sendMessage = (e) => {
     setSuccessMessage('');
     setErrorMessage('')
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    DataService.sendMessage(formData)
      .then((response) => {
      setSuccessMessage('Your message has been sent successfully!');
        // Optionally clear form:
        setFormData({ name: '', email: '', mobile_number: '', message: '' });
      })
      .catch((error) => {
       setErrorMessage('Internal Server Error.')
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div>
        <Helmet>
        {/* Primary Meta Tags */}
        <title>Contact Us | Divine Blush Beauty | Regina SK Beauty Salon</title>
        <meta name="title" content="Contact Us | Divine Blush Beauty | Regina SK Beauty Salon" />
        <meta name="description" content="Get in touch with Divine Blush Beauty in Regina, SK. Contact us for bookings, inquiries, or questions about our beauty services. Call +1-639-915-0949 or visit us at 3104 Crossbie Cres." />
        <meta name="keywords" content="contact beauty salon Regina, Divine Blush Beauty contact, beauty salon Regina address, book appointment Regina, Regina SK beauty services, contact salon Regina" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.divineblushbeauty.ca/contact" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.divineblushbeauty.ca/contact" />
        <meta property="og:title" content="Contact Us | Divine Blush Beauty | Regina SK" />
        <meta property="og:description" content="Get in touch with Divine Blush Beauty in Regina, SK. Contact us for bookings, inquiries, or questions about our beauty services." />
        <meta property="og:image" content="https://www.divineblushbeauty.ca/images/contact_Banner.jpg" />
        <meta property="og:site_name" content="Divine Blush Beauty" />
        <meta property="og:locale" content="en_CA" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.divineblushbeauty.ca/contact" />
        <meta name="twitter:title" content="Contact Us | Divine Blush Beauty | Regina SK" />
        <meta name="twitter:description" content="Get in touch with Divine Blush Beauty in Regina, SK. Contact us for bookings, inquiries, or questions." />
        <meta name="twitter:image" content="https://www.divineblushbeauty.ca/images/contact_Banner.jpg" />

        {/* Additional SEO */}
        <meta name="geo.region" content="CA-SK" />
        <meta name="geo.placename" content="Regina" />

        {/* Structured Data - Contact Page */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ContactPage",
              "mainEntity": {
                "@type": "BeautySalon",
                "name": "Divine Blush Beauty",
                "url": "https://www.divineblushbeauty.ca",
                "logo": "https://www.divineblushbeauty.ca/images/Logo_salon.svg",
                "image": "https://www.divineblushbeauty.ca/images/contact_Banner.jpg",
                "telephone": "+1-639-915-0949",
                "email": "info@divineblushbeauty.ca",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "3104, Crossbie Cres",
                  "addressLocality": "Regina",
                  "addressRegion": "SK",
                  "postalCode": "S4V3S2",
                  "addressCountry": "CA"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": "50.4452",
                  "longitude": "-104.6189"
                },
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+1-639-915-0949",
                  "contactType": "Customer Service",
                  "availableLanguage": ["English"],
                  "areaServed": "CA"
                }
              }
            }
          `}
        </script>
      </Helmet>
        <section
          className="hero-wrap hero-wrap-2"
          style={{ backgroundImage: "url('images/contact_Banner.jpg')" }}
        >
          <div className="overlay" />
          <div className="container">
            <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
              <AnimateOnScroll className="col-md-9 text-center">
                <h1 className="mb-3 bread">Contact us</h1>
                <p className="breadcrumbs">
                  <span className="mr-2">
                    <Link to="/">Home</Link>
                  </span>
                  <span>Contact us</span>
                </p>
              </AnimateOnScroll>
            </div>
          </div>
        </section>

        <section className="ftco-section contact-section">
          <div className="container">
            
            <div className="row block-9">
              <AnimateOnScroll className="col-md-4 contact-info ftco-animate bg-light p-4">
                <div className="row">
                  <img src="images/contact.png" alt="contact" />
                </div>
              </AnimateOnScroll>

              <div className="col-md-1" />
              <AnimateOnScroll className="col-md-6">
                 {successMessage && (
                  <div className="alert-success mb-4 p-3 rounded text-white animate-fade-in">
                    {successMessage}
                  </div>
                )}
                {errorMessage && (
                  <div className="alert-error mb-4 p-3 rounded text-white animate-fade-in">
                    {errorMessage}
                  </div>
                )}
                <form className="contact-form" onSubmit={sendMessage}>
                  <div className="row">
                    <div className="col-md-6">
                      <FormInput
                        label="Your Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        error={errors.name}
                      />
                    </div>
                    <div className="col-md-6">
                      <FormInput
                        label="Your Email"
                        name="email"
                        type="text"
                        value={formData.email}
                        onChange={handleChange}
                        error={errors.email}
                      />
                    </div>
                  </div>

                  <FormInput
                   maxLength={12}
                    label="Mobile Number"
                    name="mobile_number"
                    type="number"
                    value={formData.mobile_number}
                    onChange={handleChange}
                    error={errors.mobile_number}
                  />

                  <FormInput
                    maxLength={2000}
                    label="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    error={errors.message}
                    textarea
                  />

                  <div className="form-group">
                    <button
                      type="submit"
                      className="btn btn-primary py-3 px-5"
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : 'Send Message'}
                    </button>
                  </div>
                </form>
              </AnimateOnScroll>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
